import * as React from 'react';
import LogIn from '../containers/LogIn' 

export default (props) => <LogIn {...props} />
